module.exports = __webpack_public_path__ + "img/bleu-1.e0019e9e.png";